import Win10Card from "../Win10Card";

export default function WerkOpdrachtCard({
  werkbon,
  canEdit = false,
  value = "",
  onChange,
  onSave,
  saving = false,
  error = "",
}) {
  const tekst =
    werkbon?.omschrijving ||
    werkbon?.opdracht?.omschrijving ||
    werkbon?.scope?.samenvatting ||
    buildSimpleScopeFallback(werkbon?.scope) ||
    "Geen werkopdracht opgegeven.";


  return (
    <Win10Card title="Werkopdracht">
      {!canEdit ? (
        <p className="whitespace-pre-line text-sm leading-relaxed text-gray-800">
          {tekst}
        </p>
      ) : (
        <div className="space-y-3">
          <textarea
            value={value}
            onChange={(event) => onChange?.(event.target.value)}
            rows={8}
            className="w-full rounded border border-slate-300 p-3 text-sm leading-relaxed"
            placeholder="Werkopdracht omschrijving"
          />
          {error && <p className="text-sm text-red-600">{error}</p>}
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onSave}
              disabled={saving}
              className="rounded bg-blue-600 px-3 py-2 text-sm text-white hover:bg-blue-700 disabled:opacity-60"
            >
              {saving ? "Opslaan..." : "Werkopdracht opslaan"}
            </button>
          </div>
        </div>
      )}

    </Win10Card>
  );
}

function buildSimpleScopeFallback(scope) {
  if (!scope || typeof scope !== "object") return "";

  const parts = [];
  const binnen = toList(scope.binnen);
  const buiten = toList(scope.buiten);
  const toelichting = String(scope.toelichting || "").trim();

  if (binnen.length > 0) parts.push(...binnen);
  if (buiten.length > 0) parts.push(...buiten);
  if (toelichting) parts.push(toelichting);

  return parts.join("\n").trim();
}

function toList(value) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || "").trim()).filter(Boolean);
  }

  const text = String(value || "").trim();
  return text ? [text] : [];
}
